export const transcript = {
  convertTimestampToSeconds: (timestamp: string): number | null => {
    const split = timestamp.split(":");
    if (split.length !== 2) {
      return null;
    }

    const minutes = parseInt(split[0], 10);
    const seconds = parseInt(split[1], 10);
    if (!Number.isFinite(minutes) || !Number.isFinite(seconds)) {
      return null;
    }

    return minutes * 60 + seconds;
  },
  /** Extracts valid transcript lines from an untyped transcript payload. */
  parseLines: (
    payload: unknown,
  ): { content: string; role: string; time: string }[] | null => {
    if (!payload || typeof payload !== "object") return null;

    const transcriptLines = (payload as { transcriptLines?: unknown })
      .transcriptLines;
    if (!Array.isArray(transcriptLines)) return null;

    return transcriptLines.filter(
      (line): line is { content: string; role: string; time: string } => {
        return (
          !!line &&
          typeof line === "object" &&
          typeof (line as { content?: unknown }).content === "string" &&
          typeof (line as { role?: unknown }).role === "string" &&
          typeof (line as { time?: unknown }).time === "string"
        );
      },
    );
  },
};
